export const beachTypes = [
  {
    id: 16,
    name: 'Собственный пляж',
  },
  {
    id: 17,
    name: 'Песчаный пляж',
  },
  {
    id: 18,
    name: 'Галечный пляж',
  },
];

export default beachTypes;
